import {FaPencilAlt, FaPlus, FaTrash} from "react-icons/fa";
import React from "react";

const BillingPeriodsTable = (setSelectedRow, setFormModal, setDeleteModal) => {
    return [
        {
            Header: 'Payment term',
            accessor: 'period_name',
        },
        {
            id: 'actions',
            Header: () => {
                return (
                    <FaPlus
                        color='#22af47'
                        size={18}
                        title="Create"
                        onClick={() => {
                            setSelectedRow({});
                            setFormModal({isOpen: true, action: 'create'});
                        }}
                    />
                )
            },
            Cell: (cell) => {
                const row = cell.row.original;
                return (
                    <>
                        <FaPencilAlt
                            className="actions"
                            title="Edit"
                            onClick={() => {
                                setSelectedRow(row);
                                setFormModal({isOpen: true, action: 'edit'});
                            }}
                        />
                        {' '}
                        <FaTrash
                            className="actions"
                            title="Delete"
                            onClick={() => {
                                const msg = <p>Are you sure you want to delete payment term <b>{row.period_name}</b></p>;
                                setSelectedRow(row);
                                setDeleteModal({
                                    message: msg,
                                    isOpen: true,
                                })
                            }}
                        />
                    </>
                )
            }
        }
    ];
}

export default BillingPeriodsTable;



